import { render, staticRenderFns } from "./addProgramme.vue?vue&type=template&id=22abb6c8&"
import script from "./addProgramme.vue?vue&type=script&lang=js&"
export * from "./addProgramme.vue?vue&type=script&lang=js&"
import style0 from "./addProgramme.vue?vue&type=style&index=0&id=22abb6c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports